// extracted by mini-css-extract-plugin
export var logo = "_m0-2";
export var logoWrapper = "_m0-1";
export var strip = "_m0-0";